import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from "react";
import BtnSubmit from "app/Components/Shared/Buttons/BtnSubmit";
import CheckBox from "app/Components/Shared/CheckBox/Checkbox";
import {
    getSubscribers, handleSetError, replaceSim, setCurrentStep,
    setSubscriber, simNumberAvailabilityCheck,
    simReplacementInit
} from "app/Components/Block/SimReplacementBlock/simReplacementSlice";
import {hideAppLoader, showAppLoader} from "app/Components/Shared/Loader/LoaderSlice";
import {connect} from "react-redux";
import Config from "app/Config";
import {
    dwhConfirmSimReplacementButton,
    dwhDisplayConfirmationPopUp,
    dwhSuccess
} from "app/Components/Block/SimReplacementBlock/reports/dwhReports";


const ConfirmationPopUp = (props) => {
    const [checked, setChecked] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        dwhDisplayConfirmationPopUp(props.simReplacementState?.simNumber, props.userData?.loginData?.userDetails?.firstName + " " + props.userData?.loginData?.userDetails?.lastName, props.simReplacementState?.subscriber, props.userData?.loginData?.userDetails?.IDNumber, props.simReplacementState?.payload?.userBan)
    }, []);

    const handleCheckBox = () => {
        setChecked(!checked);
        if (!checked) {
            setError("");
        }
    }

    const handleSubmit = async () => {
        dwhConfirmSimReplacementButton(props.simReplacementState?.simNumber, props.userData?.loginData?.userDetails?.firstName + " " + props.userData?.loginData?.userDetails?.lastName, props.simReplacementState?.subscriber, props.userData?.loginData?.userDetails?.IDNumber, props.simReplacementState?.payload?.userBan)
        setError('');
        if (!checked) {
            setError('כדי להמשיך, יש לאשר שקראת את ההודעה');
            return;
        }
        let request = {
            oldSim: props.simReplacementState.payload.oldSimNo,
            newSim: props.simReplacementState?.simNumber,
            newSimItemId: props.simReplacementState.payload.newSimItemId,
            userPhoneNumber: props.simReplacementState.subscriber,
            userIdType: props.simReplacementState.payload.idType,
            userIdNumber: props.simReplacementState.payload.idNumber,
            todayDate: new Date().toISOString().slice(0,10).replace(/-/g,""),
            userBan: props.simReplacementState.payload.userBan
        }
        props.replaceSim(request);
    }
    return (
        <div className={'confirmation-popUp-content'}>
            <div className={'top-content'}>
                <Image src={Config.epiBaseUrl + props.iContent.popUpMainImage.value.url} alt={"info"} />
                <span className='popup-title'>{props.iContent.popUpTitle.value}</span>
            </div>
            <div className={'info-list'}>
                {props.iContent.popUpInfoList.expandedValue.map((infoItem, index) => {
                    return <>
                        <div className={'list-item'}>
                            <Image className={'check-icon'} src={require('../images/check.svg')} alt={"info"} />
                            {infoItem.name}
                        </div>
                        {index !== (props.iContent.popUpInfoList.expandedValue.length - 1) &&
                            <div className={'horizontal-divider'}/>}
                    </>

                })}

            </div>
            <CheckBox checked={checked} label={"קראתי והבנתי"} id={"confirmationCheckBox"}
                      onChange={handleCheckBox}></CheckBox>
            <div className={'field-error'}>
                {error}
            </div>
            <BtnSubmit
                text={props.iContent.popUpSubmitButtonText.value}
                onclick={handleSubmit}
            />
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        simReplacementState: state.SimReplacement,
        userData: state.authentication,
    }
};

const mapDispatchToProps = {
    setSubscriber,
    getSubscribers,
    simReplacementInit,
    setCurrentStep,
    showAppLoader,
    hideAppLoader,
    handleSetError,
    simNumberAvailabilityCheck,
    replaceSim
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationPopUp);
